"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmeraldBreadcrumbCoreInputs = exports.Crumb = exports.EmeraldBreadcrumbLink = exports.OVERFLOW_ICON_COLOR = exports.DEFAULT_OVERFLOW_CRUMB_POSITION = exports.DEFAULT_MAX_INLINE_CRUMBS = exports.DEFAULT_OVERFLOW_TEXT = exports.DEFAULT_CRUMB_DELIMETER = void 0;
/* eslint-disable @typescript-eslint/no-inferrable-types */
exports.DEFAULT_CRUMB_DELIMETER = '/';
exports.DEFAULT_OVERFLOW_TEXT = '...';
exports.DEFAULT_MAX_INLINE_CRUMBS = 3;
exports.DEFAULT_OVERFLOW_CRUMB_POSITION = 2;
exports.OVERFLOW_ICON_COLOR = '#003f2d';
var EmeraldBreadcrumbLink;
(function (EmeraldBreadcrumbLink) {
    EmeraldBreadcrumbLink["Path"] = "Path";
    EmeraldBreadcrumbLink["Url"] = "Url";
    EmeraldBreadcrumbLink["None"] = "None";
})(EmeraldBreadcrumbLink || (exports.EmeraldBreadcrumbLink = EmeraldBreadcrumbLink = {}));
class Crumb {
}
exports.Crumb = Crumb;
class EmeraldBreadcrumbCoreInputs {
    constructor() {
        this.crumbs = [];
        this.delimeter = exports.DEFAULT_CRUMB_DELIMETER;
        this.delimeterIcon = 'chevron_right';
    }
}
exports.EmeraldBreadcrumbCoreInputs = EmeraldBreadcrumbCoreInputs;
//# sourceMappingURL=breadcrumb.inputs.js.map